module.exports = __webpack_public_path__ + "static/img/14010101.9c0d86f2.png";